export const PaymentsApiEndpoints = {
  FETCH_FEES_LIST: "/rest-api/fee-player/search",
  FETCH_FEE_ADMIN_TEAMS: "/rest-api/fee/admin/teams",
  FETCH_PLAYERS: "/rest-api/fee/organization-player",
  CREATE_STRIPE_PAYMENT_INTENT: "/rest-api/fee/payment",
  FETCH_FEE_PAYMENT_DETAILS: "/rest-api/fee-payment-installment/details",

  // WHY ARE THESE URLS THE SAME?
  FETCH_FEE_SUMMARY: "/rest-api/fee-player",
  DELETE_FEE: "/rest-api/fee-player",
  CANCEL_FEE: "/rest-api/fee-player/cancel",
  FETCH_FEE_DETAILS: "/rest-api/fee-player",
  SEARCH_ORGANIZATION_PLAYERS: "/api/v1/playersForCreateFee",

  CREATE_FEE: "/api/v1/createPlayerFees",
  FETCH_PLAYER_FEES: "/api/v1/playerFees",
  FETCH_PAYMENT_ACCOUNTS: "/rest-api/fee/payment-accounts",
  FETCH_FEE: "/paypal/playerFee",
  EXPORT_FEES_CSV: "/o/",
  UPDATE_FEE: "/o/"
};
